// Import presentation images
import PrezentacjaC from '../assets/PrezentacjaC.png';
import PrezentacjaI from '../assets/PrezentacjaI.png';
import PrezentacjaR from '../assets/PrezentacjaR.png';
import PrezentacjaS from '../assets/PrezentacjaS.png';
import PrezentacjaK from '../assets/PrezentacjaK.png';
import PrezentacjaY from '../assets/PrezentacjaY.png';

// --- Miot C Images ---
import miotC_1 from '../assets/Miot C/Miot C/69aa487b-5865-42cc-a64a-20236b653e01.JPG';
import miotC_2 from '../assets/Miot C/Miot C/IMG_8170.JPG';
import miotC_3 from '../assets/Miot C/Miot C/IMG_8557.jpg';
import miotC_4 from '../assets/Miot C/Miot C/IMG_8678.JPG';
import miotC_5 from '../assets/Miot C/Miot C/IMG_8929.JPG';
import miotC_6 from '../assets/Miot C/Miot C/IMG_9468.jpg';
import miotC_7 from '../assets/Miot C/Miot C/IMG_9696.JPG';

// --- Miot I Images (existing) ---
import miotI_1 from '../assets/MiotI/0-1.jpeg';
import miotI_2 from '../assets/MiotI/0-2.jpeg';
import miotI_3 from '../assets/MiotI/0-3.jpeg';
import miotI_4 from '../assets/MiotI/0-4.jpeg';
import miotI_5 from '../assets/MiotI/0-5.jpeg';
import miotI_6 from '../assets/MiotI/0-6.jpeg';
import miotI_46 from '../assets/MiotI/0-46.jpeg';
import miotI_49 from '../assets/MiotI/0-49.jpeg';
import miotI_50 from '../assets/MiotI/0-50.jpeg';
import miotI_51 from '../assets/MiotI/0-51.jpeg';
import miotI_53 from '../assets/MiotI/0-53.jpeg';
import miotI_54 from '../assets/MiotI/0-54.jpeg';
import miotI_kopia from '../assets/MiotI/0-kopia.jpeg';
import miotI_0 from '../assets/MiotI/0.jpeg';
import miotI_POZ_0199 from '../assets/MiotI/POZ_0199-Poprawione-Szum.jpg';
import miotI_POZ_0178 from '../assets/MiotI/POZ_0178-Poprawione-Szum.jpg';
import miotI_POZ_0148 from '../assets/MiotI/POZ_0148-Poprawione-Szum.jpg';

// --- Miot I Images (new) ---
import miotI_new_1 from '../assets/Miot I/Miot I/09116548-a4d3-4bf1-ba21-caef447e4703.JPG';
import miotI_new_2 from '../assets/Miot I/Miot I/2792927b-41d6-484a-bbc0-98a0480b409e.JPG';
import miotI_new_3 from '../assets/Miot I/Miot I/5296be0d-da7c-47ef-be3a-48aa24d1169d.JPG';
import miotI_new_4 from '../assets/Miot I/Miot I/IMG_0282.JPG';
import miotI_new_5 from '../assets/Miot I/Miot I/IMG_0350.JPG';
import miotI_new_6 from '../assets/Miot I/Miot I/IMG_0417.JPG';
import miotI_new_7 from '../assets/Miot I/Miot I/IMG_0462.JPG';
import miotI_new_8 from '../assets/Miot I/Miot I/IMG_1188.JPG';
import miotI_new_9 from '../assets/Miot I/Miot I/IMG_1191.JPG';
import miotI_new_10 from '../assets/Miot I/Miot I/IMG_1729.jpg';
import miotI_new_11 from '../assets/Miot I/Miot I/IMG_1746.jpg';
import miotI_new_12 from '../assets/Miot I/Miot I/IMG_1748.jpg';
import miotI_new_13 from '../assets/Miot I/Miot I/IMG_1763.JPG';
import miotI_new_14 from '../assets/Miot I/Miot I/IMG_1774.jpg';
import miotI_new_15 from '../assets/Miot I/Miot I/IMG_2131.jpg';
import miotI_new_16 from '../assets/Miot I/Miot I/IMG_2138.JPG';
import miotI_new_17 from '../assets/Miot I/Miot I/IMG_2146.jpg';
import miotI_new_18 from '../assets/Miot I/Miot I/IMG_2156.jpg';
import miotI_new_19 from '../assets/Miot I/Miot I/IMG_2641.JPG';
import miotI_new_20 from '../assets/Miot I/Miot I/IMG_4460.JPG';
import miotI_new_21 from '../assets/Miot I/Miot I/IMG_4973.jpg';
import miotI_new_22 from '../assets/Miot I/Miot I/IMG_6760.JPG';
import miotI_new_23 from '../assets/Miot I/Miot I/IMG_9045.JPG';
import miotI_new_24 from '../assets/Miot I/Miot I/aeccb92d-5df3-4567-a988-9bf946e39c38.JPG';
import miotI_new_25 from '../assets/Miot I/Miot I/d9e2d84f-2531-456d-8f18-58f5708c93d3.JPG';

// --- Miot R Images (existing) ---
import miotR_0 from '../assets/MiotR/0.jpeg';
import miotR_4 from '../assets/MiotR/0-4.jpeg';
import miotR_6 from '../assets/MiotR/0-6.jpeg';
import miotR_8 from '../assets/MiotR/0-8.jpeg';
import miotR_52 from '../assets/MiotR/0-52.jpeg';
import miotR_IMG_7950 from '../assets/MiotR/IMG_7950.jpeg';

// --- Miot R Images (new) ---
import miotR_new_1 from '../assets/Miot r/Miot r/8bec7c14-c54c-4ecb-aa95-ef8ad2da0661.JPG';
import miotR_new_2 from '../assets/Miot r/Miot r/IMG_7902.JPG';
import miotR_new_3 from '../assets/Miot r/Miot r/IMG_8618.PNG';
import miotR_new_4 from '../assets/Miot r/Miot r/IMG_8677.JPG';
import miotR_new_5 from '../assets/Miot r/Miot r/IMG_9271.jpg';
import miotR_new_6 from '../assets/Miot r/Miot r/ca3df7c2-c85a-49b4-b158-bc94d66fc294.jpg';

// --- Miot S Images (new) ---
import miotS_new_1 from '../assets/Miot s/Miot s/441a1635-04a6-4589-a973-a5ced025c54a.JPG';
import miotS_new_2 from '../assets/Miot s/Miot s/514bef76-0273-4a37-a3d4-c8be735c1407.JPG';
import miotS_new_3 from '../assets/Miot s/Miot s/IMG_0092.JPG';
import miotS_new_4 from '../assets/Miot s/Miot s/IMG_0093.JPG';

// --- Miot Y Images ---
import miotY_28 from '../assets/MiotY/0-28.jpeg';
import miotY_29 from '../assets/MiotY/0-29.jpeg';
import miotY_30 from '../assets/MiotY/0-30.jpeg';
import miotY_31 from '../assets/MiotY/0-31.jpeg';
import miotY_32 from '../assets/MiotY/0-32.jpeg';
import miotY_33 from '../assets/MiotY/0-33.jpeg';
import miotY_34 from '../assets/MiotY/0-34.jpeg';
import miotY_35 from '../assets/MiotY/0-35.jpeg';
import miotY_36 from '../assets/MiotY/0-36.jpeg';
import miotY_37 from '../assets/MiotY/0-37.jpeg';
import miotY_41 from '../assets/MiotY/0-41.jpeg';
import miotY_42 from '../assets/MiotY/0-42.jpeg';
import miotY_IMG_4934 from '../assets/MiotY/IMG_4934.jpg';
import miotY_IMG_4962 from '../assets/MiotY/IMG_4962.jpg';
import miotY_IMG_4992 from '../assets/MiotY/IMG_4992.jpg';
import miotY_IMG_5098 from '../assets/MiotY/IMG_5098.jpg';
import miotY_IMG_1147 from '../assets/MiotY/IMG_1147.jpeg';
import miotY_IMG_1389 from '../assets/MiotY/IMG_1389.jpeg';
import miotY_301 from '../assets/MiotY/301477880_604410037941403_790955376158045333_n.jpg';

// --- Miot K Images ---
import IMG_2152 from '../assets/Miot k/Miot k/IMG_2152.jpg';
import miotK_2 from '../assets/Miot k/Miot k/IMG_2449.jpg';
import miotK_3 from '../assets/Miot k/Miot k/IMG_2865.jpg';
import miotK_4 from '../assets/Miot k/Miot k/IMG_3567_Facetune_25-09-2021-12-03-57.jpg';
import miotK_5 from '../assets/Miot k/Miot k/IMG_3571_Facetune_25-09-2021-12-11-38.jpg';
import miotK_6 from '../assets/Miot k/Miot k/IMG_3610_Facetune_28-09-2021-07-34-58.jpg';

export const littersData = [
  {
    id: 'miot-c',
    letter: 'C',
    date: '4 kwietnia 2024',
    presentationImage: PrezentacjaC,
    gallery: [miotC_1, miotC_2, miotC_3, miotC_4, miotC_5, miotC_6, miotC_7],
    description: {
      pl: 'Miot „C" przyniósł nam jedną, wyjątkową suczkę – Charlotte Etsuko w kolorze biało-czarnym.\n\nNasza mała księżniczka została z nami i każdego dnia zachwyca nas swoją osobowością.\n\nZ dumą reprezentuje hodowlę Etsuko na wystawach, zdobywając pierwsze sukcesy.',
      en: 'Litter "C" brought us one exceptional female – Charlotte Etsuko in white and black color.\n\nOur little princess stayed with us and enchants us with her personality every day.\n\nShe proudly represents Etsuko kennel at dog shows, achieving her first successes.'
    }
  },
  {
    id: 'miot-i',
    letter: 'I',
    date: '30 czerwca 2024',
    presentationImage: PrezentacjaI,
    gallery: [
      miotI_POZ_0199, miotI_POZ_0178, miotI_POZ_0148, miotI_1, miotI_2, miotI_3, miotI_4, miotI_5, miotI_6, miotI_46, miotI_49, miotI_50, miotI_51, miotI_53, miotI_54, miotI_kopia, miotI_0,
      miotI_new_1, miotI_new_2, miotI_new_3, miotI_new_4, miotI_new_5, miotI_new_6, miotI_new_7, miotI_new_8, miotI_new_9, miotI_new_10, miotI_new_11, miotI_new_12, miotI_new_13, miotI_new_14, miotI_new_15, miotI_new_16, miotI_new_17, miotI_new_18, miotI_new_19, miotI_new_20, miotI_new_21, miotI_new_22, miotI_new_23, miotI_new_24, miotI_new_25
    ],
    description: {
      pl: 'W naszej hodowli przyszedł na świat wyjątkowy miot „I" – cztery urocze szczenięta w kolorach biało-cytrynowym i biało-czarnym: dwóch samców i dwie suczki.\n\nI\'m Your Fantasy Etsuko zamieszkał we Włoszech,\nI Should Be So Lucky at Anjuli Etsuko zamieszkał w Szkocji,\nI Did It Again Etsuko została w Polsce,\na I Have a Dream Etsuko mieszka z nami i jest częścią naszej hodowli ❤️\n\nKażde z tych szczeniąt bierze udział w wystawach kynologicznych, z dumą reprezentując hodowlę Etsuko w kraju i za granicą. Jesteśmy niezwykle dumni z ich rozwoju, urody i cudownych charakterów.',
      en: 'In our kennel, an exceptional litter "I" was born – four lovely puppies in white-lemon and white-black colors: two males and two females.\n\nI\'m Your Fantasy Etsuko moved to Italy,\nI Should Be So Lucky at Anjuli Etsuko moved to Scotland,\nI Did It Again Etsuko stayed in Poland,\nand I Have a Dream Etsuko lives with us and is part of our kennel ❤️\n\nEach of these puppies participates in dog shows, proudly representing Etsuko kennel at home and abroad. We are extremely proud of their development, beauty and wonderful characters.'
    }
  },
  {
    id: 'miot-r',
    letter: 'R',
    date: '31 marca 2024',
    presentationImage: PrezentacjaR,
    gallery: [
      miotR_IMG_7950, miotR_0, miotR_4, miotR_6, miotR_8, miotR_52,
      miotR_new_1, miotR_new_2, miotR_new_3, miotR_new_4, miotR_new_5, miotR_new_6
    ],
    description: {
      pl: 'W miocie „R" na świat przyszła trójka biało-czerwonych maluchów – dwóch samców i jedna suczka.\n\nRaphael Etsuko oraz Rhaenyra Etsuko zamieszkali wspólnie w Anglii, gdzie już niedługo będzie można podziwiać ich na ringach wystawowych. Trzymamy za nich mocno kciuki!\n\nRaichu Etsuko został w Polsce, gdzie cieszy swoją rodzinę jako ukochany towarzysz i wierny przyjaciel.',
      en: 'In litter "R", three white and red little ones came into the world – two males and one female.\n\nRaphael Etsuko and Rhaenyra Etsuko moved together to England, where they will soon be admired in show rings. We keep our fingers crossed for them!\n\nRaichu Etsuko stayed in Poland, where he delights his family as a beloved companion and faithful friend.'
    }
  },
  {
    id: 'miot-s',
    letter: 'S',
    date: '10 luty 2023',
    presentationImage: PrezentacjaS,
    gallery: [miotS_new_1, miotS_new_2, miotS_new_3, miotS_new_4],
    description: {
      pl: 'W miocie „S" urodził się jeden biało-czarny samczyk – Sannatis Etsuko.\n\nZostał w rodzinie i mieszka z moją mamą, gdzie pełni najważniejszą rolę – kochanego towarzysza i codziennego pocieszyciela.',
      en: 'In litter "S", one white and black male was born – Sannatis Etsuko.\n\nHe stayed in the family and lives with my mother, where he plays the most important role – a beloved companion and daily comforter.'
    }
  },
  {
    id: 'miot-k',
    letter: 'K',
    date: '30 lipca 2021',
    presentationImage: PrezentacjaK,
    gallery: [IMG_2152, miotK_2, miotK_3, miotK_4, miotK_5, miotK_6],
    description: {
      pl: 'W miocie „K" urodził się jeden wyjątkowy samiec – biało-czarny Kenichi Etsuko.\n\nZostał w rodzinie jako ukochany towarzysz, który każdego dnia wypełnia dom radością i miłością.',
      en: 'In litter "K", one exceptional male was born – white and black Kenichi Etsuko.\n\nHe stayed in the family as a beloved companion who fills the house with joy and love every day.'
    }
  },
  {
    id: 'miot-y',
    letter: 'Y',
    date: '3 sierpnia 2022',
    presentationImage: PrezentacjaY,
    gallery: [ miotY_IMG_4934, miotY_IMG_4962, miotY_IMG_4992, miotY_IMG_5098, miotY_IMG_1147, miotY_IMG_1389, miotY_301, miotY_28, miotY_29, miotY_30, miotY_31, miotY_32, miotY_33, miotY_34, miotY_35, miotY_36, miotY_37, miotY_41, miotY_42 ],
    description: {
      pl: 'W miocie „Y" przyszły na świat trzy wyjątkowe szczenięta: biało-cytrynowy samiec oraz dwie suczki – biało-czarna i biało-sobolowa.\n\nYoshimitsu Etsuko i jego siostra Yumi Etsuko (biało-czarna) pozostały z nami i z radością oraz sukcesami reprezentują naszą hodowlę na wystawach.\n\nDruga suczka, Yumiko Etsuko (biało-sobolowa), mieszka w Polsce i każdego dnia jest kochanym i wiernym towarzyszem swojej rodziny, wnosząc do ich życia mnóstwo radości i ciepła.',
      en: 'In litter "Y", three exceptional puppies came into the world: a white and lemon male and two females – white and black, and white and sable.\n\nYoshimitsu Etsuko and his sister Yumi Etsuko (white and black) stayed with us and joyfully and successfully represent our kennel at dog shows.\n\nThe second female, Yumiko Etsuko (white and sable), lives in Poland and is a beloved and faithful companion to her family every day, bringing lots of joy and warmth to their lives.'
    }
  }
]; 